import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useAuth = () => {
  const { isAuthenticated, isValidatingToken, loginUser, impersonatedUser } = useSelector((state) => state.auth);
  let {
    assignedCountries,
    assignedRegions,
    assignedLocations,
    assignedLocationObjects,
    assignedBusinessLines,
    assignedRequestCategories,
    dateFormat,
    dateTimeFormat,
    permissionSet,
    customPermissions,
    token,
    username
  } = loginUser || {};

  const { user, roles } = loginUser || {};

  let userId = user?.UserID;
  let roleLevel = loginUser?.roleLevel;
  let timezone = user ? user.Timezone : '';
  let firstName = user?.FirstName;
  let lastName = user?.LastName;

  window.onbeforeunload = () => {
    localStorage.removeItem('impersonateToken');
  };

  if (impersonatedUser) {
    token = impersonatedUser.token;
    roleLevel = impersonatedUser?.roleLevel;
    userId = impersonatedUser.user?.UserID;
    username = impersonatedUser.username;
    firstName = impersonatedUser.user?.FirstName;
    lastName = impersonatedUser.user?.LastName;
    assignedCountries = impersonatedUser.assignedCountries;
    assignedRegions = impersonatedUser.assignedRegions;
    assignedLocations = impersonatedUser.assignedLocations;
    assignedLocationObjects = impersonatedUser.assignedLocationObjects;
    assignedBusinessLines = impersonatedUser.assignedBusinessLines;
    assignedRequestCategories = impersonatedUser.assignedRequestCategories;
    dateFormat = impersonatedUser.dateFormat;
    dateTimeFormat = impersonatedUser.dateTimeFormat;
    permissionSet = impersonatedUser.permissionSet;
    customPermissions = impersonatedUser.customPermissions;
    if (impersonatedUser.user) {
      timezone = impersonatedUser.user.Timezone;
    }
  }

  if (!dateFormat || `${dateFormat}`.toLowerCase() === 'null') {
    dateFormat = 'dd/MM/yyyy';
  }

  if (!dateTimeFormat || `${dateTimeFormat}`.toLowerCase() === 'null') {
    dateTimeFormat = 'dd/MM/yyyy HH:mm';
  }

  const isAuthorized = useCallback(
    ({ permissionCode, right }) => {
      if (!permissionSet || !permissionCode) {
        return false;
      }

      const permissionOptions = permissionSet[permissionCode.toLowerCase()];
      if (!Array.isArray(permissionOptions) || permissionOptions.length === 0) {
        return false;
      }

      return permissionOptions.includes(right);
    },
    [permissionSet]
  );

  const hasCustomFunction = useCallback(
    (customFunctionCode) => {
      if (!Array.isArray(customPermissions) || customPermissions.length <= 0
        || !customFunctionCode) {
        return false;
      }

      return customPermissions.includes(customFunctionCode.toLocaleLowerCase());
    },
    [customPermissions]
  );

  return {
    isAuthenticated,
    isValidatingToken,
    user,
    token,
    username,
    firstName,
    lastName,
    permissionSet,
    assignedCountries,
    assignedRegions,
    assignedLocations,
    assignedLocationObjects,
    assignedBusinessLines,
    assignedRequestCategories,
    dateFormat,
    dateTimeFormat,
    userId,
    timezone,
    isAuthorized,
    hasCustomFunction,
    roles,
    roleLevel
  };
};

export default useAuth;
